import {defineStore} from "pinia";
import LoginInfoRepository from "@/menu/models/repository/loginInfoRepository";
import LoginInfoUc from "@/menu/use_cases/loginInfoUc";
import Cookies from "js-cookie";
import {getDomainCookie} from "@/utils/env";
import User from "@/menu/models/class/loginInfo/user";
import {markRaw} from "vue";
import {getApi} from "@/shared/axios";

export const useLoginStore = defineStore("login", {
  state: () => {
    return {
      userInfo: new User(),
      userProjects: [],
      position: '',
      actualProjectId: '',
      theme: 'light',
      uc: null,
    }
  },
  getters: {
    getCities() {
      return this.cities
    },
  },
  actions: {
    initializeConfig() {
      if (this.uc) return

      const api = getApi()

      const repository = new LoginInfoRepository(api)
      this.uc = new LoginInfoUc(repository)
    },
    setActualProjectId(value) {
      this.actualProjectId = value
    },
    getStateValue(stateKey) {
      return localStorage.getItem(stateKey)
    },
    updateStateValue(stateKey, value) {
      localStorage.setItem(stateKey, value);
      Cookies.set(stateKey, value, {domain: getDomainCookie()})

      if (stateKey === "theme") {
        this.theme = value
        document.body.classList.toggle("dark-mode", value === "dark")
      }
    },
    async getLoggedUser() {
      try {
        const response = await this.uc.loginUserStatusUc()
        this.userInfo = markRaw(response.user)

        return response.status
      } catch (error) {
        console.error("getLoggedUser -> ", error)
      }
    },
    getActualProject() {
      return this.userProjects.find(project => project.getId() === this.actualProjectId)
    },
    setUserProjects(city) {
      const projects = []
      this.userInfo.getProjects().forEach(project => {
        if (project.getCity() === city) {
          projects.push(markRaw(project))
        }
      })
      this.userProjects = projects
      if (this.userProjects.length > 0) {
        const actualProject = this.getStateValue("actualProjectId")
        let index = 0
        if (actualProject) {
          index = this.userProjects.findIndex(project => project.getId() === actualProject)
        }

        this.updateStateValue("actualCompanyId", this.userProjects[index].getCompanyId())
        this.updateStateValue("actualProjectId", this.userProjects[index].getId())
        this.setActualProjectId(this.userProjects[index].getId())
      } else {
        this.updateStateValue("actualCompanyId", "")
        this.updateStateValue("actualProjectId", "")
        this.setActualProjectId("")
      }
    },
    pageLoadedORRefreshed() {
      const lsTheme = localStorage.getItem("theme") || "light"
      this.theme = lsTheme
      document.body.classList.toggle("dark-mode", lsTheme === "dark")
      const selectedCity = localStorage.getItem("selectedCity")
      Cookies.set("theme", lsTheme, {domain: getDomainCookie()})
      Cookies.set("selectedCity", selectedCity, {domain: getDomainCookie()})
    }
  }
})
